import { forwardRef } from 'react';

interface PulsatingLogoProps {
  size: number;
  animated?: boolean;
  style?: React.CSSProperties;
}

export const PulsatingLogo = forwardRef<HTMLDivElement, PulsatingLogoProps>(
  ({ size, animated = true, style }, ref) => {
    return (
      <div ref={ref} style={style}>
        <div
          style={
            {
              animation: animated
                ? 'logo-pulse 1.2s ease-in-out infinite, logo-vibrate-x 0.08s linear infinite, logo-vibrate-y 0.08s linear infinite 0.04s, float 4s ease-in-out infinite'
                : 'none',
              willChange: animated ? 'transform' : 'auto',
              '--float-amplitude': '8px',
            } as React.CSSProperties
          }
        >
          <img
            src="/LearnBahn.png"
            alt="LearnBahn"
            style={{
              height: size,
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        </div>
      </div>
    );
  }
);

PulsatingLogo.displayName = 'PulsatingLogo';
